<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="公司名称" prop="c_type">
                <el-select v-model="searchCondition.corp_id" filterable clearable placeholder="请选择公司">
                    <el-option
                        v-for="item in componyListData"
                        :key="item.id"
                        :label="item.label"
                        :value="item.val">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审核状态" prop="status">
                <el-select v-model="searchCondition.status" filterable clearable placeholder="请选择状态">
                    <el-option
                        v-for="(item,index) in billStatusList"
                        :key="index"
                        :label="item.label"
                        :value="item.val">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="日期">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-tabs v-model="corp_type" type="card" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
          </el-tab-pane>
          
          <ApeTable v-permission:business_list ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" :current_Page="currentPage" @switchPaging="switchPaging" highlight-current-row >

          <el-table-column
            slot="first-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="top">
                <div>{{ scope.row.company_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              slot="second-column"
              width="160"
              align="center"
              label="确认函">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="mxPreview(scope.row.bill_url)" >
                  <i class="iconfont iconwenjian iconbtn iconBtns"></i>
                </el-button>
                <el-button size="mini" type="text" @click="mxGoUrl(scope.row.bill_url)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
          <el-table-column
            slot="second-column"
            width="160"
            align="center"
            label="业务清单">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="mxPreview(scope.row.file_url)">
                  <i class="iconfont iconwenjian iconbtn iconBtns" @click="downButton(scope.row)"></i>
                </el-button>
                <el-button size="mini" type="text" @click="mxGoUrl(scope.row.file_url)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              slot="second-column"
              prop="money"
              align="center"
              sortable
              label="成功金额">
              <template slot-scope="scope">
                <div class="tag-group">
                  <el-tag type="warning" class="tag-item">
                    <div>成功金额：{{scope.row.success_money}}</div>
                  </el-tag>
                  <el-tag type="warning" class="tag-item">
                    <div>成功人数：{{scope.row.success_num}}</div>
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="180"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <span>
                  <el-button v-permission:business_refuse size="mini" type="danger" v-if="scope.row.status == 0"  @click="refuse(scope.row.id, '2')">拒绝</el-button>
                  <el-button v-permission:business_adopt size="mini" type="primary" @click="showTG(scope.row.id, '1')" v-if="scope.row.status == 0">通过</el-button>
                </span>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="refuseData" :rules="refuseRules" ref="refuseForm" label-position="right" label-width="96px">
          <el-radio-group v-model="reason" class="reason" @change="changeReason">
            <el-radio v-for="(item, index) in this.rejectList" :label="item.label" :key="index" :name="item.name" class="tab-item">{{item.name}}</el-radio>
          </el-radio-group>
          <el-form-item label="拒绝原因" prop="remark">
            <el-input v-model="refuseData.remark" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
    <verification
      @dialogChanged="dialogBillChanged($event)"
      @onSuccess="handleBillSuccess($event)"
      :dialogBillVisible="dialogBillVisible"
      :billId="billId" />
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import Verification from '@/components/Verification.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    Verification
  },
  data() {
    return {
      billStatusList:[{
          label:'待审核',
          val:'0'
      },
      {
          label:'已通过',
          val:'1'
      },
      {
          label:'已拒绝',
          val:'2'
      }],
      componyListData:[],
      rejectList: [
            {
              label: 1,
              name: '服务金额与附件表中金额不符'
            },
            {
              label: 2,
              name: '服务金额是实际下发金额，不含税'
            },
            {
              label: 3,
              name: '确认函未盖章'
            },
            {
              label: 4,
              name: '业务清单结算依据和结算量填写不正确'
            }
      ],
      reason: '',
      currentPage: 1,
      refuseData: {//拒绝提交数据
        remark: ''
      },
      refuseRules: {
        remark: [
         { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        ]
      },
      corp_type: '1',
      tabsList: [
          {
              label: '人资公司',
              name: '1'
          },
          {
              label: '用工企业',
              name: '2'
          },
      ],
      billId: '',
      dialogBillVisible: false,
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: false,
      columns: [
            {
              title: '批次提交时间',
              value: 'submit_time',
              header_align: 'center',
              align: 'center',
            },
            {
              title: '审核状态',
              value: 'alias_status',
              width: 120,
              header_align: 'center',
              align: 'center',
            },
      ],
      // 表格列表数据
      dataList:[  ],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 添加附件
      dialogData:{
        visible: false,
        title: '系统操作',
        width: '30%',
        loading: true,
        modal: false
      },
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    },
    "refuseData.remark" : function(v) {
      if(v) {
        this.dialogData.loading = false
      }else {
        this.dialogData.loading = true
      }
    },
    "reason": function(v) {
      if(v) {
        this.dialogData.loading = false
        this.rejectList.forEach(item => {
          if(item.label == v) {
            this.refuseData.remark = item.name
          }
        })
      }else {
        this.dialogData.loading = true
      }
    }
  },
  methods: {
      showTG(arg,val){
        this.$confirm('确定要通过吗？', '提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
           }).then(() => {
              this.formSubmit(arg,val)
      }).catch(() => {

      })
    },
    // 重置分页
    async resetPage() {
      this.$refs.apeTable.currentPage = 1
    },
    //选择原因
    changeReason() {
      this.rejectList.forEach(item => {
        if(item.label == this.reason) {
          this.refuseData.remark = item.name
        }
      })
    },
    //拒绝
    refuse(id, status) {
      this.dialogData.visible = true
      this.refuseData.id = id
      this.refuseData.status = status
    },
    //点击tab切换
    async handleClick(tab) {
        this.searchCondition={status:'',corp_id:'',time:''};
        this.corp_type = tab.name;
        this.resetPage()
        this.allCompanyList()
        this.init('search')
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    // 切换页码操作
    async switchPaging(val) {
      if(val) {
        this.currentPage = val
      }else {
        this.currentPage = 1
      }
      this.init()
    },
    
    handleBillSuccess() {
      this.$message.success('验证成功')
      this.dialogBillVisible = false
    },
    dialogBillChanged(state) {
      this.dialogBillVisible = state
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化列表
    async init(type) {
      if(type) {
        this.resetPage()
      }
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo,{corp_type: this.corp_type})
      let { data, pages} = await this.$api.getBillList(searchCondition)
      this.$nextTick(() => {
        this.dataList = data
        this.dataList.map((item)=>{
            item.visiblePass = false
        })
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    async allCompanyList() {
        let result = [];
        let data = {
            page_size:9999,
            current_page:1,
            status:1
        };
        if(this.corp_type==1){
            result = await this.$api.getPaihuoHumanResourcesList(data)
        }else if(this.corp_type==2){
            result = await this.$api.getPaihuoEmploymentList(data)
        }else{
            return;
        }
      let arr = []
      
      result.items.map(item => {
        let obj = {
            label: item.company_name,
            val: item.id
        }
        arr.push(obj)
      })
      this.componyListData = arr
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status
      }
      if (this.searchCondition.channel_name) {
        condition.channel_name = this.searchCondition.channel_name
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      if (this.searchCondition.corp_id) {
        condition.corp_id = this.searchCondition.corp_id
      }
      return condition
    },
    // form数据提交，请求接口
    async formSubmit(id,status) {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      let data = {
          status
      }
      if(this.refuseData?.remark){
          data.remark = this.refuseData?.remark
      }
      var res = await this.$api.postBillStatus(id,data)
      this.$nextTick(() => {
        this.dialogClose()
        if (res) {
          this.$message.success('保存成功!')
          this.init()
        }
      })
    
    },
    async formRefuseSubmit( ){
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formSubmit(this.refuseData.id,this.refuseData.status)
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['refuseForm'].validate((valid) => {
        if (valid) {
          this.formRefuseSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.reason = ''
      this.refuseData = {}
    },
    keyupSubmit(){
      document.onkeydown = () => {
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },
  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-input-group__prepend, .el-input-group__append
    background #ffffff
    padding 0 12px
  .el-input-group__append
    color #ffffff
    background #1890ff
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .table-right
    float right
  .changeBtn
    display: flex
    flex-direction: row
    width: 1110px
  // .demo-form-inline
  //   padding-top: 20px
  .iconBtns
    font-size 20px
    color rgba(0, 183, 158, 1)
  .el-form--inline .el-form-item
    margin-right: 30px
  .reason
    display: flex
    flex-direction: column
    padding-left: 20px
    padding-bottom: 10px
  .tag-group
    display: flex
    flex-direction: column
  .tag-item
    margin: 5px 0
  // .table-search
  //   height: 36px
</style>
